var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 397.4 397.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 198.7,
    y1: 0,
    x2: 198.7,
    y2: 397.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0ecf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3de2fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5881fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c513ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.7,0h0C89,0,0,89,0,198.7h0c0,109.7,89,198.7,198.7,198.7h0c109.7,0,198.7-89,198.7-198.7h0C397.4,89,308.4,0,198.7,0ZM293.2,167.2c0,2.1-1.8,3.9-3.9,3.8-40.1-1.1-51.2-19.6-51.2-19.6v94.5c0,37-30,66.9-66.9,66.9s-71-34.2-66.5-74.6c3.4-30.6,28.1-55.4,58.7-58.9,4.1-.5,8.2-.6,12.2-.3,2,.1,3.5,1.8,3.5,3.8v27.9c0,2.3-2,4-4.3,3.8-2.6-.3-5.3-.3-8.1.1-13.9,1.9-25,13.3-26.7,27.2-2.4,19.7,13.4,36.3,32.8,35.4,17-.8,30-15.6,30-32.6V88.1c0-2.1,1.7-3.8,3.8-3.8h31.7c2,0,3.8,1.5,3.9,3.6,1.4,21.9,16.2,45.8,47.4,47.5,2.1.1,3.7,1.8,3.7,3.8v28h-.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokCircle);
export default __webpack_public_path__ + "static/media/tiktok-circle.c40db8a955480a68efc42720f7e7423f.svg";
export { ForwardRef as ReactComponent };